import React from 'react';
import { maxWidthContainer } from '@noths/polaris-client-ribbons-base';

import { header, wrapper } from 'src/styles/styles';

export function ApplyToSellWithUsContainer({ children }: { children: React.ReactNode }) {
  return (
    <section css={maxWidthContainer}>
      <h1 css={header}>Apply to sell with us</h1>
      <section css={wrapper}>{children}</section>
    </section>
  );
}
